import { render } from "./PayoutGuessPrevPage.vue?vue&type=template&id=0bb2b039"
import script from "./PayoutGuessPrevPage.vue?vue&type=script&lang=js"
export * from "./PayoutGuessPrevPage.vue?vue&type=script&lang=js"

import "./PayoutGuessPrevPage.vue?vue&type=style&index=0&id=0bb2b039&lang=css"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__